<div class="picture" [ngClass]="{ 'small-icon': smallIcon}">
    <img *ngIf="staticImagePath" [src]="imgSrc" alt="{{ staticImageAlt }}"/>
    <img *ngIf="isSVG && !staticImagePath" [src]="imageUrl" alt="{{ imageAlt }}" />
    <img *ngIf="!isSVG && !staticImagePath" src="{{ imageUrl }}" [attr.srcset]="isStaticSize? imageUrl: imageUrl2x" alt="{{ imageAlt }}" />
</div>
